<template>
  <div class="login-wrap">
    <div class="login-logo">
      <router-link to="/">
        <img src="http://placehold.it/100x100/efefef/?text=LOGO" alt />
      </router-link>
    </div>
    <div class="card card-login">
      <template v-if="!pleaseConfirmEmail">
        <div class="card-header">
          <h1 class="card-title">Create an Account</h1>
        </div>
        <div class="card-body">
          <b-form @submit.prevent="submit">
            <validation-summary :errors="errors"></validation-summary>

            <v-form-group :validator="$v.email" label="Email">
              <b-form-input v-model="email" />
            </v-form-group>
            <v-form-group :validator="$v.firstName" label="First Name">
              <b-form-input v-model="firstName" />
            </v-form-group>
            <v-form-group :validator="$v.lastName" label="Last Name">
              <b-form-input v-model="lastName" />
            </v-form-group>
            <form-input-password v-model="password"
                                 :validator="$v.password"
                                 label="New Password">
            </form-input-password>
            <form-input-password v-model="confirmPassword"
                                 :validator="$v.confirmPassword"
                                 label="Confirm New Password">
            </form-input-password>
            <div class="form-group">
              <b-btn class="btn-block" type="submit">Create</b-btn>
            </div>
          </b-form>
        </div>
      </template>
      <template v-else>
        <div class="card-header">
          <h1 class="card-title">Confirm Email Address</h1>
        </div>
        <div class="card-body text-center">
          <p>We've just sent an email to {{ email }}.</p>
          <p>Please follow the link in that email to verify your account and complete registration.</p>
        </div>
      </template>
    </div>
    <div class="bottom-text">
      Already have an account?
      <router-link to="/login">Sign In</router-link>
    </div>
  </div>
</template>

<script>
import { required, email, sameAs } from "vuelidate/lib/validators";
import { password } from "utils/custom-validators";
import formMixin from "mixins/form-mixin";
import accountService from "services/account-service";

export default {
  mixins: [formMixin],

  data() {
    return {
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      pleaseConfirmEmail: false
    };
  },

  validations: {
    email: {
      required,
      email
    },
    firstName: {
      required
    },
    lastName: {
      required
    },
    password: {
      required,
      password
    },
    confirmPassword: {
      required,
      confirmPassword: sameAs("password")
    }
  },

  methods: {
    async onSubmit() {
      let res = await accountService.register({
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        password: this.password
      });

      if (res.canLogin) {
        await this.$auth.login(this.email, this.password, false, "/");
        return;
      }

      if (res.requireConfirmedEmail) this.pleaseConfirmEmail = true;
    }
  }
};
</script>